import 'intersection-observer';
import 'object-fit-videos';
import assign from 'core-js/library/fn/object/assign';
Object.assign = assign;

if (!Array.includes) {
  require('core-js/fn/array/includes');
}
if (!Array.find) {
  require('core-js/fn/array/find');
}
if (!Array.findIndex) {
  require('core-js/fn/array/find-index');
}
if (!('classList' in SVGElement.prototype)) {
  /*
    React OnClick Outside library requires svgs to support classList,
    IE11 that doesn't have em so.. adding a shim to resolve this issue.
  */
  Object.defineProperty(SVGElement.prototype, 'classList', {
    get() {
      return {
        contains: className => {
          return this.className.baseVal.split(' ').indexOf(className) !== -1;
        },
      };
    },
  });
}
